import type { Folder } from "certiblok-api-manager";
import { useMemo } from "react";
import CertiblokIcon, { CertiblokIconNames } from "../icons/CertiblokIcon";
import ReservedFolderWhiteTooltip from "./ReservedFolderWhiteTooltip";

type FolderIconProps = {
	folder: Folder;
	parentFolder?: Folder;
	disableReservationIcon?: boolean;
};
const FolderIcon: React.FC<FolderIconProps> = ({ folder, parentFolder, disableReservationIcon }) => {
	const isReserved = (folder?.reservedToUserIds?.length ?? 0) > 0 || (folder?.reservedToTeamIds?.length ?? 0) > 0;

	const parentReservedUsers = parentFolder
		? parentFolder?.reservedToUserIds ?? []
		: folder.parentFolder?.reservedToUserIds ?? [];
	const parentReservedTeams = parentFolder
		? parentFolder?.reservedToTeamIds ?? []
		: folder.parentFolder?.reservedToTeamIds ?? [];

	const currentReservedUsers = new Set(
		(folder?.reservedToUserIds ?? [])?.filter(
			(user) => parentReservedUsers.length === 0 || parentReservedUsers.includes(user)
		)
	);

	const currentReservedTeams = new Set(
		(folder?.reservedToTeamIds ?? [])?.filter(
			(team) => parentReservedTeams.length === 0 || parentReservedTeams.includes(team)
		)
	);

	const isMoreRestricted = useMemo(() => {
		const parentTotal = parentReservedUsers.length + parentReservedTeams.length;
		const currentTotal = currentReservedUsers.size + currentReservedTeams.size;

		// If parent has no restrictions but current does, it's more restricted
		if (parentTotal === 0 && currentTotal > 0) return true;

		// If parent has more total restrictions than current
		return parentTotal > currentTotal;
	}, [currentReservedUsers, currentReservedTeams, parentReservedUsers, parentReservedTeams]);

	const iconName: CertiblokIconNames = folder.isSdsFolder
		? "swap_bold"
		: isMoreRestricted && !disableReservationIcon
		? "lock_bold_02"
		: "folder_bold";

	return (
		<ReservedFolderWhiteTooltip enabled={isReserved && !disableReservationIcon} folder={folder}>
			<CertiblokIcon size={24} color={folder.color} name={iconName} />
		</ReservedFolderWhiteTooltip>
	);
};
export default FolderIcon;
